import { type LandingPageKind, type LandingSectionConfig, type LandingSectionType } from "../entities/LandingPage";
import { type LandingSectionDefinition } from "./fields";
import { bikiniSectionDefinitions } from "./groups/bikini/definitions";
import { bikiniTemplates } from "./groups/bikini/templates";
import { bikini2026SectionDefinitions } from "./groups/bikini2026/definitions";
import { bikini2026Templates } from "./groups/bikini2026/templates";
import { bikiniContinueSectionDefinitions } from "./groups/bikiniContinue/definitions";
import { bikiniContinueTemplates } from "./groups/bikiniContinue/templates";
import { commonSectionDefinitions } from "./groups/common/definitions";
import { commonTemplates } from "./groups/common/templates";
import { postPurchaseSectionDefinitions } from "./groups/postPurchase/definitions";
import { postPurchaseTemplates } from "./groups/postPurchase/templates";
import { resetSectionDefinitions } from "./groups/reset/definitions";
import { resetTemplates } from "./groups/reset/templates";
import { type LandingTemplate } from "./template";

export * from "./fields";
export * from "./template";
export { funnelSectionTypes, type FunnelSectionType } from "./sectionTypes";

/** Editor schema and defaults of every funnel template section type. */
export const funnelSectionDefinitions: Partial<Record<LandingSectionType, LandingSectionDefinition>> = {
  ...commonSectionDefinitions,
  ...bikiniSectionDefinitions,
  ...bikini2026SectionDefinitions,
  ...resetSectionDefinitions,
  ...postPurchaseSectionDefinitions,
  ...bikiniContinueSectionDefinitions,
};

export const getFunnelSectionDefinition = (type: LandingSectionType): LandingSectionDefinition | undefined =>
  funnelSectionDefinitions[type];

/** Every page of the offer shipped as a builder template, in admin order. */
export const landingTemplates: LandingTemplate[] = [
  ...commonTemplates,
  ...bikiniTemplates,
  ...bikini2026Templates,
  ...resetTemplates,
  ...bikiniContinueTemplates,
  ...postPurchaseTemplates,
];

export const getLandingTemplatesByKind = (kind: LandingPageKind) =>
  landingTemplates.filter((template) => template.kind === kind);

/** What the step loader must add for these sections (e.g. the Reset group). */
export const getSectionDataNeeds = (sections: Pick<LandingSectionConfig, "type" | "enabled">[]) =>
  new Set(
    sections
      .filter((section) => section.enabled)
      .flatMap((section) => funnelSectionDefinitions[section.type]?.needs ?? []),
  );
